import { CoreMenu } from 'src/@core/types';

export const projectsMenu: CoreMenu[] = [
  {
    id: 'Projects-group',
    title: 'Projects',
    type: 'collapsible',
    icon: 'project.svg',
    role: {
      roles: ['employee'],
      right: ['H1015', 'H1004', 'H1000'],
    },
    children: [
      {
        id: 'Projects',
        title: 'Projects',
        type: 'item',
        icon: 'project.svg',
        url: '/i-team/projects',
        role: {
          roles: ['employee'],
          right: 'H1015',
        },
      },
      {
        id: 'Modules',
        title: 'Modules',
        type: 'item',
        icon: 'modules.svg',
        url: '/i-team/modules',
        role: {
          roles: ['employee'],
          right: 'H1004',
        },
      },
      {
        id: 'SubModules',
        title: 'Sub Modules',
        type: 'item',
        icon: 'modules.svg',
        url: '/i-team/submodules',
        role: {
          roles: ['employee'],
          right: 'H1263',
        },
      },
      {
        id: 'Features',
        title: 'Features',
        type: 'item',
        icon: 'features.svg',
        url: '/i-team/features',
        role: {
          roles: ['employee'],
          right: 'H1000',
        },
      },
      {
        id: 'Milestones',
        title: 'Milestones',
        type: 'item',
        icon: 'milestones.svg',
        url: '/i-team/milestones',
        role: {
          roles: ['employee'],
          right: 'H1152',
        },
      },
    ],
  },
];
